import type { Theme } from 'baseui';
export const SELECT_OVERRIDES = {
  Root: {
    style: ({
      $theme
    }) => ({
      backgroundColor: $theme.colors.backgroundSecondary,
      borderRadius: $theme.borders.radius300,
      width: 'auto'
    })
  },
  ValueContainer: {
    style: ({
      $theme
    }) => ({
      ...$theme.typography.LabelMedium,
      paddingTop: $theme.sizing.scale200,
      paddingBottom: $theme.sizing.scale200,
      paddingLeft: $theme.sizing.scale300,
      color: $theme.colors.contentTertiary
    })
  },
  IconsContainer: {
    style: ({
      $theme
    }) => ({
      paddingRight: $theme.sizing.scale300
    })
  },
  SelectArrow: {
    props: {
      overrides: {
        Svg: {
          style: ({
            $theme
          }) => ({
            color: $theme.colors.contentTertiary
          })
        }
      }
    }
  },
  Input: {
    style: ({
      $theme
    }) => ({
      ...$theme.typography.LabelMedium,
      color: $theme.colors.contentTertiary
    })
  },
  DropdownListItem: {
    style: ({
      $theme
    }) => ({
      padding: `${$theme.sizing.scale200} ${$theme.sizing.scale300}`
    })
  },
  OptionContent: {
    style: ({
      $theme
    }) => ({
      ...$theme.typography.LabelMedium,
      color: $theme.colors.contentTertiary
    })
  }
};
export const INPUT_PADDING_HORIZONTAL = ($theme: Theme) => $theme.sizing.scale300;
export const INPUT_PADDING_VERTICAL = ($theme: Theme) => $theme.sizing.scale200;
const INPUT_PAIR_OVERRIDES = {
  Root: {
    style: ({
      $theme
    }) => ({
      borderRadius: $theme.borders.radius300,
      padding: `${INPUT_PADDING_VERTICAL($theme)} ${INPUT_PADDING_HORIZONTAL($theme)}`
    })
  },
  Input: {
    style: ({
      $theme
    }) => ({
      ...$theme.typography.LabelMedium,
      padding: 0,
      color: $theme.colors.contentTertiary,
      textAlign: 'right'
    })
  },
  EndEnhancer: {
    style: {
      flexShrink: 0,
      padding: 0
    }
  }
};
export const SLIDER_OVERRIDES = {
  Root: {
    style: () => ({
      paddingTop: 0,
      paddingBottom: 0
    })
  },
  Track: {
    style: ({
      $theme
    }) => ({
      paddingTop: 0,
      paddingBottom: 0
    })
  },
  Thumb: {
    style: ({
      $theme
    }) => ({
      width: $theme.sizing.scale500,
      height: $theme.sizing.scale500,
      backgroundColor: $theme.colors.contentPrimary
    })
  },
  InnerTrack: {
    style: ({
      $theme
    }) => ({
      backgroundColor: $theme.colors.borderOpaque
    })
  },
  InnerThumb: {
    style: () => ({
      display: 'none'
    })
  },
  ThumbValue: {
    style: () => ({
      display: 'none'
    })
  },
  TickBar: {
    style: () => ({
      display: 'none'
    })
  }
};
export const getWidthOverrides = (calculatedWidth: number) => {
  return {
    props: {
      // Expose measured width for testing and debugging
      'data-width-px': Math.max(0, calculatedWidth)
    },
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => {
      const paddingHorizontal = INPUT_PADDING_HORIZONTAL($theme);
      const borderWidth = $theme.sizing.scale0;
      return {
        width: `calc(${calculatedWidth}px + ${paddingHorizontal} + ${paddingHorizontal} + ${borderWidth} + ${borderWidth})`,
        minWidth: $theme.sizing.scale1000
      };
    }
  };
};
export const getInputOverridesWithWidth = (calculatedWidth: number) => {
  const widthOverrides = getWidthOverrides(calculatedWidth);
  return {
    ...INPUT_PAIR_OVERRIDES,
    Root: {
      ...INPUT_PAIR_OVERRIDES.Root,
      props: widthOverrides.props,
      style: ({
        $theme
      }: {
        $theme: Theme;
      }) => ({
        ...INPUT_PAIR_OVERRIDES.Root.style({
          $theme
        }),
        ...widthOverrides.style({
          $theme
        })
      })
    }
  };
};